"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ElementResponses;
(function (ElementResponses) {
    var ViewContentTypeElementResponse = /** @class */ (function () {
        /**
        * Response containing content type element
        *
        * @constructor
        * @param {GenericElement} element - Content type element
        * @param {ICloudResponseDebug} debug - Debug information from the response
        */
        function ViewContentTypeElementResponse(element, debug) {
            this.element = element;
            this.debug = debug;
        }
        return ViewContentTypeElementResponse;
    }());
    ElementResponses.ViewContentTypeElementResponse = ViewContentTypeElementResponse;
})(ElementResponses = exports.ElementResponses || (exports.ElementResponses = {}));
//# sourceMappingURL=responses.js.map


// WEBPACK FOOTER //
// ./node_modules/kentico-cloud-delivery/_commonjs/models/element/responses.js